import { Theme } from '@mui/material';

/** Returns the sidenav surface color for the current app theme mode. */
export function getSidenavBackgroundColor(theme: Theme): string {
  return theme.palette.mode === 'dark'
    ? theme.palette.sidenav.backgroundAppDark
    : theme.palette.sidenav.background;
}

/** Returns the sidenav text color (fixed light text on the dark sidenav surface). */
export function getSidenavTextColor(theme: Theme): string {
  return theme.palette.sidenav.text;
}

/** Hover/focus tint for sidenav interactive elements. */
export function getSidenavHoverBackground(theme: Theme): string {
  return theme.palette.sidenav.hover;
}

/** Shared icon button styles for sidenav footer actions. */
export function getSidebarIconButtonSx(theme: Theme) {
  const textColor = getSidenavTextColor(theme);
  const hoverBackground = getSidenavHoverBackground(theme);

  return {
    color: textColor,
    '&:hover': {
      background: hoverBackground,
      color: textColor,
    },
    '&:focus': {
      background: hoverBackground,
      color: textColor,
    },
  };
}
